import { render, staticRenderFns } from "./mindex.vue?vue&type=template&id=47201260&scoped=true&"
import script from "./mindex.vue?vue&type=script&lang=js&"
export * from "./mindex.vue?vue&type=script&lang=js&"
import style0 from "./mindex.vue?vue&type=style&index=0&id=47201260&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47201260",
  null
  
)

export default component.exports